var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.01875C9.16 2.01875 10.1 3.0175 10.1 4.25C10.1 5.4825 9.16 6.48125 8 6.48125C6.84 6.48125 5.9 5.4825 5.9 4.25C5.9 3.0175 6.84 2.01875 8 2.01875ZM8 11.5813C10.97 11.5813 14.1 13.1325 14.1 13.8125V14.9813H1.9V13.8125C1.9 13.1325 5.03 11.5813 8 11.5813ZM8 0C5.79 0 4 1.90188 4 4.25C4 6.59812 5.79 8.5 8 8.5C10.21 8.5 12 6.59812 12 4.25C12 1.90188 10.21 0 8 0ZM8 9.5625C5.33 9.5625 0 10.9863 0 13.8125V17H16V13.8125C16 10.9863 10.67 9.5625 8 9.5625Z",
    fill: "#09334B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.fec8987a1bedad7f623438d4a1094dff.svg";
export { ForwardRef as ReactComponent };